import React from 'react';
import { useLoadingMessageStore } from 'app/platform/stores/loadingMessageStore';
import { LoadingPill } from 'app/components/common/LoadingPill';

const LoadingMessageOverlay: React.FC = () => {
  const isVisible = useLoadingMessageStore((s) => s.isVisible);
  const message = useLoadingMessageStore((s) => s.message);

  if (!isVisible) return null;

  return (
    <>
      {/* Background overlay to block user input and gray out the background */}
      <div className="fixed inset-0 bg-black bg-opacity-20 z-[9998] pointer-events-auto" />

      <div className="fixed top-6 left-1/2 transform -translate-x-1/2 z-[9999]">
        <LoadingPill message={message} />
      </div>
    </>
  );
};

export default LoadingMessageOverlay;
